import SectionComponent from "@inter-ikea-storagetwo/range/dist/components/SectionComponent";
import InsertComponent from "@inter-ikea-storagetwo/range/dist/components/InsertComponent";
import UprightComponent from "./UprightComponent";
import MountingRailComponent from "./MountingRailComponent";
import NonWorldlyItemComponent from "@inter-ikea-storagetwo/range/dist/components/NonWorldlyItemComponent";
import ColorComponent from "@inter-ikea-storagetwo/range/dist/components/ColorComponent";
import ProductTypeComponent from "@inter-ikea-storagetwo/range/dist/components/ProductTypeComponent";
import InsertAttachmentComponent from "./InsertAttachmentComponent";
import AdjustableDataComponent from "@inter-ikea-storagetwo/range/dist/components/AdjustableDataComponent";
import AdjustableStateComponent from "@inter-ikea-storagetwo/range/dist/components/AdjustableStateComponent";
import MergeableComponent from "@inter-ikea-storagetwo/range/dist/components/MergeableComponent";
import ProhibitedReplacementComponent from "@inter-ikea-storagetwo/range/dist/components/ProhibitedReplacementComponent";
export const components = {
    SectionComponent,
    InsertComponent,
    UprightComponent,
    MountingRailComponent,
    NonWorldlyItemComponent,
    ColorComponent,
    ProductTypeComponent,
    ProhibitedReplacementComponent,
    AdjustableDataComponent,
    AdjustableStateComponent,
    InsertAttachmentComponent,
    MergeableComponent,
};
